export default from './LoanOfficerInfoBar';



// WEBPACK FOOTER //
// ./src/sharedComponents/LoanOfficerInfoBar/index.js